import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, FormArray } from '@angular/forms';
import { Asset, Contracts } from '@/interfaces/new-license-request/new-license-request-interfaces';
import { toBeEqualTo } from '@/validators/toBeEqualTo';
import { toBeWithin } from '@/validators/toBeWithin';
import { CommonService } from '@/services/common/common.service';
import { RequirementService } from '@/services/requirement/requirement.service';
import { FormGroupWithErrors } from './FormGroupWithErrors';

const licenseExistErrorText = `Esta persona ya tiene una licencia creada en el sitio seleccionado, para registrar un nuevo vehículo
o zona debes hacerlo en Ampliación de licencia.`;
const infractionErrorText = 'Esta persona tiene una infracción vigente.';
const requirementExistErrorText = 'Esta persona tiene una solicitud de licencia vigente.';

@Component({
  selector: 'app-form-asset-contract',
  templateUrl: './form-asset-contract.component.html',
  styleUrls: ['./form-asset-contract.component.css'],
})
export class FormAssetContractComponent implements OnInit {
  formSchema : FormGroup = new FormGroupWithErrors({
    assetId: new FormControl(0, [toBeWithin(1, 2)]),
    mdmid: new FormControl('', [Validators.required]),
    contractId: new FormControl(0, [Validators.min(1)]),
    isEmployee: new FormControl(false),
    haveLicense: new FormControl(false, [toBeEqualTo(false, licenseExistErrorText, 'haveLicense')]),
    haveInfractions: new FormControl(false, [toBeEqualTo(false, infractionErrorText)]),
    haveRequirement: new FormControl(false, [toBeEqualTo(false, requirementExistErrorText)]),
  });
  formErrors: string[] = [];

  @Input() numberSection: string = '';
  @Input() controlForm: FormGroupWithErrors = new FormGroupWithErrors({});

  get mdmId(): string {
    return this.controlForm.controls.mdmid.value as string;
  }

  get personIsEmployee(): boolean {
    return this.controlForm.controls.isEmployee.value as boolean;
  }

  assetList: Asset[] = [];
  contractList: Contracts[] = [];

  constructor(
    private commonService: CommonService,
    private requirementService: RequirementService,
  ) { }

  ngOnInit(): void {
    this.setFormGroupSchema(this.controlForm, this.formSchema);

    this.getAndSetAssets();

    const isEmployeeObserver = (isEmployee: boolean) => {
      this.controlForm.controls.contractId.clearValidators();
      this.controlForm.controls.contractId.updateValueAndValidity();
      // if (isEmployee) {
      //   this.controlForm.controls.contractId.clearValidators();
      //   this.controlForm.controls.contractId.updateValueAndValidity();
      // }
      // else {
      //   const validators = this.formSchema.controls.contractId.validator;
      //   this.controlForm.controls.contractId.setValidators(validators);
      //   this.controlForm.controls.contractId.updateValueAndValidity();
      // }
    };

    this.controlForm.controls.assetId.valueChanges.subscribe({
      next: (assetId) => {
        this.controlForm.patchValue({
          contractId: 0,
        });
        this.getAndSetContractsByAsset(assetId);

        this.checkIfDriverHaveALicense(assetId);
        this.checkIfDriverHaveARequirement(assetId);
        this.checkIfDriverHaveAnInfraction(assetId);
        isEmployeeObserver(this.personIsEmployee);
      },
    });
    this.controlForm.controls.isEmployee.valueChanges.subscribe({
      next: (isEmployee) => isEmployeeObserver(isEmployee),
    });
  }

  getAndSetAssets() {
    this.commonService.getAllAssets().subscribe((res) => {
      this.assetList = res;
    });
  }

  getAndSetContractsByAsset(assetId: number) {
    this.contractList = [];
    this.requirementService
      .getContractByAsset(assetId, this.mdmId)
      .subscribe((res) => {
        this.contractList = res;
      });
  }

  checkIfDriverHaveALicense(assetId: number) {
    this.requirementService
      .validateExistingLicense(this.mdmId, assetId)
      .subscribe((exist) => {
        this.controlForm.controls.haveLicense.setValue(exist);
      });
  }
  checkIfDriverHaveARequirement(assetId: number) {
    this.requirementService
      .validateExistingNewLicenseRequeriment({ mdmid: this.mdmId, assetId, requirementType: 1 })
      .subscribe((exist) => {
        this.controlForm.controls.haveRequirement.setValue(exist);
      });
  }

  checkIfDriverHaveAnInfraction(assetId: number) {
    this.requirementService
      .validateExistingInfraction(this.mdmId, assetId)
      .subscribe((exist) => {
        this.controlForm.controls.haveInfractions.setValue(exist);
      });
  }

  setFormGroupSchema(controlForm: FormGroup, formSchema: FormGroup) {
    const groupValidators = formSchema.validator;
    controlForm.setValidators(groupValidators);

    const controlSchemaKeys = Object.keys(formSchema.controls);
    controlSchemaKeys.map((key) => {
      const schema = formSchema.controls[key];
      let control = controlForm.controls[key];
      if (!control) {
        this.controlForm.addControl(key, this.getControlInstance(schema));
        control = controlForm.controls[key];
      }
      const validators = schema.validator;
      control.setValidators(validators);
    });
  }

  getControlInstance(abstractControl: AbstractControl) {
    if (abstractControl instanceof FormArray) {
      return new FormArray([]);
    }
    if (abstractControl instanceof FormGroup) {
      return new FormGroup({});
    }
    return new FormControl();
  }
}
